






























































































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import FilterMenu from '@/components/FilterMenu.vue';
import Paginition from '@/components/Paginition.vue';
import {Filter} from '@/utils/Filter';
import MonthlyMailSetting from '@/models/monthlymailsetting';
import {Utils} from '@/utils/Utils';
import {mapActions} from 'vuex';
import {getMonthlyEmailSetting, updateMonthlyEmailSetting} from '@/services/api/monthly-email-setting';
import {API} from '@/services/api/api';
import User from '@/models/user';
import validationMsgs from '@/constants/validation';
import validator from '@/utils/validator';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},

  components: {
    FilterMenu,
    Paginition,
  },
})
export default class MonthlyEmailSetting extends Vue {
  header = [
    {
      name: 'User Name',
      value: 'email',
      headerType: 'text',
    },
    {
      name: 'Name',
      value: 'name',
      headerType: 'text',
    },
    {
      name: 'Email',
      value: 'email',
      headerType: 'text',
    },
  ];

  setting: MonthlyMailSetting = {
    mailSubject: '',
    emailBody: '',
  };
  userList: User[] = [];
  selectedUsers: number[] = [];

  validityPeriod = [
    {
      name: '1 Week',

      key: 'weeklyMail',
    },
    {
      name: '2 Weeks',

      key: 'weekly2Mail',
    },
    {
      name: '1 Month',

      key: 'monthlyMail',
    },
    {
      name: '2 Months',

      key: 'monthly2Mail',
    },
  ];

  filteredUsers: User[] = this.userList;
  inspectionPeriod = '';

  //ui and helper methods
  startingPoint = 0;
  endingPoint = 5;
  asdcOrder = true;
  curentSort = '';

  showSuccessToast: any;
  showErrorToast: any;

  isLoading = true;
  saving = false;
  //validation variables
  emailValidationMsg = null;
  daysValidationMsg = null;

  mounted() {
    this.fetchMonthlyEmailSetting();
  }

  //validation functions
  validateEmail() {
    const subject = this.setting.mailSubject;
    if (validator.isNullOrEmpty(subject)) {
      this.emailValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.emailValidationMsg = null;
      return true;
    }
  }

  validateDayOfMail() {
    const value = this.setting.dayOfmail;
    if (!value || value < 1 || value > 28) {
      this.daysValidationMsg = 'Days must be between 1 to 28';
      return false;
    }
    if (!(value % 1 === 0)) {
      this.daysValidationMsg = 'Enter valid number';
      return false;
    }
    this.daysValidationMsg = null;
    return true;
  }

  validateAll() {
    return this.validateEmail() && this.validateDayOfMail();
  }

  async fetchMonthlyEmailSetting() {
    try {
      this.isLoading = true;
      let response = await getMonthlyEmailSetting();
      let userResp: any = await API.getUserList();
      let users: User[] = userResp.data;
      this.userList = users;
      this.filteredUsers = users;

      if (response.data) {
        let data: MonthlyMailSetting = response.data;
        this.setting = data;
        this.mapUiView();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isLoading = false;
    }
  }

  async onSubmitClick() {
    if (this.isLoading) return;
    if (!this.validateAll()) {
      return;
    }
    this.saving = true;
    const emailSetting = this.mapPostData();
    try {
      const response: any = await updateMonthlyEmailSetting(emailSetting);
      if (response.data) {
        this.setting = response.data;
        this.mapUiView();
        this.showSuccessToast({msg: 'Record updated'});
      } else {
        this.showErrorToast({msg: response});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.saving = false;
    }
  }

  //helper methods
  mapPostData() {
    return {
      mailSubject: this.setting.mailSubject,
      closedInspection: this.setting.closedInspection,
      reInspections: this.setting.reInspections,
      monthlyEmailEnable: this.setting.monthlyEmailEnable,
      weeklyMail: this.inspectionPeriod === 'weeklyMail',
      weekly2Mail: this.inspectionPeriod === 'weekly2Mail',
      monthlyMail: this.inspectionPeriod === 'monthlyMail',
      monthly2Mail: this.inspectionPeriod === 'monthly2Mail',
      dayOfmail: Math.floor(this.setting.dayOfmail),
      MonthlyEmailUsers: this.selectedUsers.map((userId) => {
        return {UserId: userId};
      }),
    };
  }
  mapUiView() {
    if (this.setting.monthlyMail) {
      this.inspectionPeriod = 'monthlyMail';
    } else if (this.setting.monthly2Mail) {
      this.inspectionPeriod = 'monthly2Mail';
    } else if (this.setting.weekly2Mail) {
      this.inspectionPeriod = 'weekly2Mail';
    } else {
      this.inspectionPeriod = 'weeklyMail';
    }

    this.selectedUsers = this.setting.monthlyEmailUsers.map((user) => user.userId);
  }

  addUserToList(alreadySelected, id: number) {
    if (!alreadySelected) {
      this.selectedUsers = this.selectedUsers.filter((a) => a !== id);
    } else {
      this.selectedUsers.push(id);
    }
  }
  addAllUsers() {
    if (this.selectedUsers.length === this.filteredUsers.length) {
      this.selectedUsers = [];
    } else {
      this.selectedUsers = this.filteredUsers.map((user) => user.internalId);
    }
  }

  //common Fns
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredUsers);
    this.asdcOrder = sorted;
  }

  //filter data based upon string parameters
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.filteredUsers);
    this.filteredUsers = filteredData;
    this.resetPagination();
  }

  //filter data based upon date parameters
  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.filteredUsers);
    this.filteredUsers = filteredData;
    this.resetPagination();
  }

  //reset all filters and show current list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredUsers = this.userList;
      this.resetPagination();
    }
  }

  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }
}
